import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { GoalId } from '../../services/api.types'
import YumTotalPointsTable, {
  IYumTotalPointsTableDispatchProps,
  IYumTotalPointsTableProps,
} from './YumTotalPointsTable'
import { getTotalPointsProgress } from '../../views/Progress/store/ProgressActions'
import { selectTotalPointsProgress } from '../../views/Progress/store/progressSelectors'

export interface IOwnProps {
  goalId: GoalId
}

const mapStateToProps = (state: IGlobalState, ownProps: IOwnProps): IYumTotalPointsTableProps => {
  const { goalId } = ownProps
  return {
    goalId,
    pointsProgress: selectTotalPointsProgress(state, goalId),
  }
}

const mapDispatchToProps: IYumTotalPointsTableDispatchProps = {
  getTotalPointsProgress,
}

export default connect(mapStateToProps, mapDispatchToProps)(YumTotalPointsTable)
